import { useTranslation } from 'react-i18next';
import { CustomColumnProps } from './types';

/**
 * Displays whether action is required or not.
 */
export const ActionRequiredColumn = ({ column, item }: CustomColumnProps) => {
  const [t] = useTranslation(['vulnerability']);
  if (
    column.fieldName === null ||
    column.fieldName === undefined ||
    column.fieldName === ''
  ) {
    return <>-</>;
  }

  const isActionRequired = item?.[column?.fieldName];

  const actionRequired = isActionRequired ? (
    <>{t('customerAction.required', 'Required')}</>
  ) : (
    <>{t('customerAction.notRequired', 'Not Required')}</>
  );

  return actionRequired;
};
